import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-2xl" }, "Order Designs")
], -1)
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Variant:", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Code:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Quantity:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Cost:", -1)
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SKU:", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Tracking:", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1)
const _hoisted_17 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_18 = {
  key: 0,
  class: "ml-3"
}
const _hoisted_19 = { style: {"font-size":"0.75rem"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Created:", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "Approved:", -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "Transaction ID:", -1)
const _hoisted_25 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, "Address 1: ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("b", null, "Address 2: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "City: ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("b", null, "Province - Zip: ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("b", null, "Country Code: ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "Phone: ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_34 = { class: "text-xs" }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Comment")
], -1)
const _hoisted_37 = { class: "mt-2" }
const _hoisted_38 = { key: 4 }
const _hoisted_39 = { key: 5 }
const _hoisted_40 = { class: "font-bold" }
const _hoisted_41 = { key: 6 }
const _hoisted_42 = { key: 7 }
const _hoisted_43 = { key: 8 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 9 }
const _hoisted_46 = { key: 10 }
const _hoisted_47 = { key: 11 }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" Actions ")
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode("  Send to review ")
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createTextVNode("  Re-Assign ")
const _hoisted_53 = { key: 12 }
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "dialog-footer" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_SelectSellerTeam = _resolveComponent("SelectSellerTeam")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_OrderImagePreview = _resolveComponent("OrderImagePreview")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_InfoFilled = _resolveComponent("InfoFilled")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Refresh = _resolveComponent("Refresh")!
  const _component_hire_design_status_tag = _resolveComponent("hire-design-status-tag")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _normalizeProps(_guardReactiveProps(_ctx.content)), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 24,
            class: "mt-3 flex item-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_filter_table, {
                onOnFilterCallback: _ctx.onFilterCallback,
                placeholder: "Search"
              }, null, 8, ["onOnFilterCallback"]),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.status,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.status) = $event)),
                placeholder: "FFM Status",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusListAgency, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      placeholder: "FFM Status",
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tag, {
                          type: _ctx.getOrderStatusColor(item.value),
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.isManager)
                ? (_openBlock(), _createBlock(_component_SelectSellerTeam, {
                    key: 0,
                    modelValue: _ctx.params.sellerTeamId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.sellerTeamId) = $event)),
                    class: "mx-1"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.isManager)
                ? (_openBlock(), _createBlock(_component_el_select, {
                    key: 1,
                    modelValue: _ctx.params.designer,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.designer) = $event)),
                    placeholder: "Designer",
                    clearable: "",
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.designers, (seller) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: seller.id,
                          label: `${seller.fullName} - ${seller?.email}`,
                          value: seller.id,
                          clearable: ""
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_select, {
                modelValue: _ctx.params.hireDesignStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.hireDesignStatus) = $event)),
                placeholder: "Design status",
                clearable: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hireDesignStatus, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      placeholder: "Design status",
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.state.orders,
        "element-loading-text": "Loading...",
        lazy: true,
        onSelectionChange: _ctx.handleSelectionChange,
        style: {"width":"100%"},
        stripe: "",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "40"
          }),
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((props) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.items.filter(
              i => i.sku !== 'Tip'
            ), (item, iItem) => {
                return (_openBlock(), _createBlock(_component_el_row, {
                  class: "py-3 px-5",
                  gutter: 20,
                  key: iItem
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, {
                      span: 6,
                      class: "pl-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_OrderImagePreview, {
                          item: item,
                          disableEdit: true
                        }, null, 8, ["item"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 14 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, [
                              (item.productId)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                                    _createVNode(_component_router_link, {
                                      to: {
                        name: 's.product-detail',
                        params: { id: item.productId },
                      },
                                      class: "text-primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.itemName), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(item.itemName), 1))
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (item.variantTitle)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                      _hoisted_6,
                                      _createTextVNode(" " + _toDisplayString(item.variantTitle), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.catalogCode)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                      _hoisted_8,
                                      _createTextVNode(" " + _toDisplayString(item.catalogCode), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("p", null, [
                                  _hoisted_9,
                                  _createTextVNode(" " + _toDisplayString(item.quantity), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _hoisted_10,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatterDollars(item.sellerAmount)), 1)
                                ]),
                                (item.sku && item.sku != 'SKU')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                                      _hoisted_12,
                                      _createTextVNode(" " + _toDisplayString(item.sku), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                (item.trackingNumber)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                      _hoisted_14,
                                      _createTextVNode(" " + _toDisplayString(item.trackingNumber), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (item.carrier)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                      _hoisted_16,
                                      _createTextVNode(" " + _toDisplayString(item.carrier), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: column.title,
              "min-width": column.minWidth,
              props: column.dataIndex,
              align: column.align
            }, {
              default: _withCtx((scope) => [
                (column.title === 'Order')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("p", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'agency.designer.detail',
                    params: { id: scope.row._id },
                  },
                          class: "text-primary font-bold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        (
                    scope.row?.fulfillmentWarning ||
                    scope.row.addressValid === 0
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                              _createVNode(_component_el_popover, {
                                placement: "top-start",
                                width: "auto",
                                trigger: "hover"
                              }, {
                                reference: _withCtx(() => [
                                  _createVNode(_component_el_icon, { style: {"color":"red"} }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Warning)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(scope.row?.orderName), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      (scope.row.addressValid === 0)
                                        ? (_openBlock(), _createBlock(_component_el_row, {
                                            key: 0,
                                            class: "mt-3 font-light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("p", null, "Address Invalid " + _toDisplayString(scope.row?.errorMsg), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true),
                                      (scope.row?.fulfillmentWarning)
                                        ? (_openBlock(), _createBlock(_component_el_row, {
                                            key: 1,
                                            class: "mt-3 font-light"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.getWarningContent(scope.row?.fulfillmentWarning)), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("p", null, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.createdDate)), 1)
                        ]),
                        (scope.row?.approveDate)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                              _hoisted_22,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTime(scope.row.approveDate)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (scope.row?.transactionId)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                              _hoisted_24,
                              _createTextVNode(" " + _toDisplayString(scope.row?.transactionId), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (column.dataIndex === 'fullName')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("p", _hoisted_26, [
                          _createTextVNode(_toDisplayString(scope.row.fullName) + " ", 1),
                          _createVNode(_component_el_popover, {
                            placement: "top-start",
                            width: "auto",
                            trigger: "hover"
                          }, {
                            reference: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_InfoFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_row, { class: "text-x font-bold" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.row.fullName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_row, { class: "mt-3" }, {
                                    default: _withCtx(() => [
                                      _hoisted_27,
                                      _createTextVNode(" " + _toDisplayString(scope.row.address1), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (_ctx.state.order.address2)
                                    ? (_openBlock(), _createBlock(_component_el_row, {
                                        key: 0,
                                        class: "mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_28,
                                          _createTextVNode(" " + _toDisplayString(scope.row.address2), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_row, { class: "mt-2" }, {
                                    default: _withCtx(() => [
                                      _hoisted_29,
                                      _createTextVNode(" " + _toDisplayString(scope.row.city), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_row, { class: "mt-2" }, {
                                    default: _withCtx(() => [
                                      _hoisted_30,
                                      _createTextVNode(" " + _toDisplayString(scope.row.province) + " - " + _toDisplayString(scope.row.zipCode), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_row, { class: "mt-2" }, {
                                    default: _withCtx(() => [
                                      _hoisted_31,
                                      _createTextVNode(" " + _toDisplayString(scope.row.countryCode), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (scope.row.phone)
                                    ? (_openBlock(), _createBlock(_component_el_row, {
                                        key: 1,
                                        class: "mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _hoisted_32,
                                            _createTextVNode(" " + _toDisplayString(scope.row.phone), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  (scope.row.email)
                                    ? (_openBlock(), _createBlock(_component_el_row, {
                                        key: 2,
                                        class: "mt-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_33,
                                          _createTextVNode(" " + _toDisplayString(scope.row.email), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("p", _hoisted_34, _toDisplayString(`(${scope.row.countryCode} - ${scope.row.province} - ${scope.row.zipCode})`), 1)
                      ]))
                    : (column.dataIndex === 'invoice')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: {
                path: `/ag/invoices/${scope.row[column.dataIndex]?._id}`,
              },
                          class: "text-blue-600",
                          title: scope.row[column.dataIndex]?.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row[column.dataIndex]?.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "title"]))
                      : (column.dataIndex === 'status')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            (scope.row?.comment?.length > 0)
                              ? (_openBlock(), _createBlock(_component_el_popover, {
                                  key: 0,
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createVNode(_component_el_tag, {
                                      type: _ctx.getOrderStatusColor(scope.row.status),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.status)), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["type"])
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_36,
                                    _createElementVNode("p", _hoisted_37, _toDisplayString(scope.row.comment), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createBlock(_component_el_tag, {
                                  key: 1,
                                  type: _ctx.getOrderStatusColor(scope.row.status),
                                  title: _ctx.statusTitleMap.get(scope.row.status),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.statusTitleMap.get(scope.row.status)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "title"]))
                          ]))
                        : (column.dataIndex === 'orderType')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createElementVNode("p", null, [
                                _createVNode(_component_el_tag, {
                                  effect: "dark",
                                  class: "rounded",
                                  size: "small",
                                  type: scope.row?.isDropship === true ? '' : 'info'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row?.isDropship === true ? 'Dropship' : 'POD'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _createElementVNode("p", null, [
                                _createVNode(_component_el_tag, {
                                  class: "rounded",
                                  size: "small",
                                  type: scope.row?.isUseLattePayment === true ? '' : 'info'
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(scope.row?.isUseLattePayment === true
                      ? 'Latte Payment'
                      : 'Seller Payment'), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ])
                            ]))
                          : (column.dataIndex === 'addressValid')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createVNode(_component_el_tag, {
                                  type: _ctx.getAddressStatusColor(scope.row[column.dataIndex]),
                                  effect: "dark",
                                  class: "rounded",
                                  size: "small",
                                  title: _ctx.addressTitleMap.get(scope.row[column.dataIndex])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.addressTitleMap.get(scope.row[column.dataIndex])), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type", "title"])
                              ]))
                            : (column.dataIndex === 'createdDate')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.formatDateTime(scope.row[column.dataIndex])), 1))
                              : (column.dataIndex === 'designFee')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    (scope.row.designFeeValue && scope.row.designFeeValue > 0)
                                      ? (_openBlock(), _createBlock(_component_el_link, {
                                          key: 0,
                                          type: "primary"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.designFeeValue)), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : (_openBlock(), _createBlock(_component_el_link, {
                                          key: 1,
                                          type: "danger",
                                          onClick: ($event: any) => (_ctx.getDefaultDesignCost(scope.row))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatterDollars(scope.row.designFeeValue)) + " ", 1),
                                            _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Refresh)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                  ]))
                                : (column.dataIndex === 'designStatus')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      (scope.row.metadata)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createVNode(_component_hire_design_status_tag, {
                                              hireDesignStatus: scope.row.metadata.hire_design_status
                                            }, null, 8, ["hireDesignStatus"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (column.dataIndex === 'designer')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(scope.row['metadata']?.email), 1))
                                    : (column.dataIndex === 'store')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(scope.row['store']?.appShopUrl), 1))
                                      : (column.dataIndex === 'actions')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                            _createVNode(_component_el_dropdown, { trigger: "click" }, {
                                              dropdown: _withCtx(() => [
                                                _createVNode(_component_el_dropdown_menu, null, {
                                                  default: _withCtx(() => [
                                                    (_ctx.isDesigner)
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 0,
                                                          onClick: ($event: any) => (_ctx.onSubmitReview(scope.row._id, `in_review`)),
                                                          disabled: !_ctx.validateDesign(scope.row.items)
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_49,
                                                            _hoisted_50
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick", "disabled"]))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.isManager)
                                                      ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                          key: 1,
                                                          onClick: ($event: any) => (
                        _ctx.onShowReAssignModal(
                          scope.row._id,
                          scope.row.metadata?.designer
                        )
                      ),
                                                          disabled: 
                        !_ctx.validateActionWithDesignStatus(
                          scope.row.metadata?.hire_design_status
                        )
                      
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _hoisted_51,
                                                            _hoisted_52
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick", "disabled"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_button, { type: "text" }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_48,
                                                    _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_arrow_down)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(scope.row[column.dataIndex]), 1))
              ]),
              _: 2
            }, 1032, ["label", "min-width", "props", "align"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data", "onSelectionChange"]), [
        [_directive_loading, _ctx.data.isLoading]
      ]),
      _createVNode(_component_pagination, {
        total: _ctx.state.total,
        pagination: _ctx.params.page,
        "onUpdate:pagination": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.page) = $event)),
        limit: _ctx.params.limit,
        "onUpdate:limit": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.data.showExportHistory,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data.showExportHistory) = $event)),
        title: "Export History",
        width: "60%",
        top: "6vh"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table, {
                    data: _ctx.data.dataHistories.histories,
                    style: {"height":"600px","overflow":"auto"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        property: "exportDate",
                        label: "Created",
                        "min-width": 10
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.formatTime(scope.row.exportDate)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "fileName",
                        label: "File name",
                        "min-width": 25
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.fileName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "name",
                        label: "Created by",
                        "min-width": 10
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.agency.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Action",
                        "min-width": 10
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("a", {
                            href: scope.row.filePath,
                            target: "_blank",
                            class: "text-blue-600"
                          }, " Download ", 8, _hoisted_54)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_pagination, {
                    total: _ctx.data.dataHistories.total,
                    pagination: _ctx.data.dataHistories.params.page,
                    "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data.dataHistories.params.page) = $event)),
                    limit: _ctx.data.dataHistories.params.limit,
                    "onUpdate:limit": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data.dataHistories.params.limit) = $event))
                  }, null, 8, ["total", "pagination", "limit"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.data.showAssignModal,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data.showAssignModal) = $event)),
        title: "Designer reassignment",
        width: "40%",
        top: "6vh"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_55, [
            _createVNode(_component_el_button, { onClick: _ctx.closeAssignDialog }, {
              default: _withCtx(() => [
                _hoisted_56,
                _hoisted_57
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onReAsignDesigner,
              disabled: _ctx.data.selectedDesignerId === '',
              loading: _ctx.data.isLoading
            }, {
              default: _withCtx(() => [
                _hoisted_58,
                _hoisted_59
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "loading"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Designer",
                    prop: "selectedDesignerId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.data.selectedDesignerId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.selectedDesignerId) = $event)),
                        placeholder: "Choose a designer",
                        class: "ml-3"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.designers, (seller) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: seller.id,
                              label: seller.email,
                              value: seller.id,
                              disabled: seller.id === _ctx.data.currentDesignerId,
                              clearable: ""
                            }, null, 8, ["label", "value", "disabled"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Comment",
                    prop: "notes"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.data.notes,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data.notes) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 16))
}